module.exports = __webpack_public_path__ + "static/media/github.f8309897.svg";